import { SellerPageFederatedSeller, useSellerData } from '@fiverr-private/seller_pages_toolbox';
import { useSellerRole } from './useSellerRole';

export const useYearsOnFiverr = (sellerRoleId?: string) => {
    const { joinedAt } = useSellerData(selectSellerSlice);
    const sellerRole = useSellerRole(sellerRoleId);

    if ((sellerRole && !sellerRole.startingDate) || !joinedAt) {
        return 0;
    }

    const joinedDate =
        sellerRole && sellerRole.startingDate
            ? // JavaScript months are 0-indexed (0 is January, 1 is February, etc.), so subtract 1 from the month
              new Date(sellerRole.startingDate.year, sellerRole.startingDate.month - 1)
            : new Date(joinedAt * 1000);

    const currentYear = new Date().getFullYear();
    const joinedYear = joinedDate.getFullYear();

    return currentYear - joinedYear;
};

const selectSellerSlice = (seller: SellerPageFederatedSeller) => ({
    joinedAt: seller.user.joinedAt,
});
